/**
 * Widget settings' `?tab=` keys. The URL says what the tab is called
 * (`?tab=contact-form`, `?tab=after-diagnosis`, `?tab=app-handoff`; third
 * live review, 2026-09-27), and every older key — the config group
 * (`capture`, `routing`, `handoff`) and the aliases people tried (`form`,
 * `contact`, `after`, `app`, `routing-actions`) — still opens the same tab.
 */
import type { ConfigGroup } from './model';

export const TAB_SLUGS: Record<ConfigGroup, string> = {
  branding: 'branding',
  copy: 'copy',
  scope: 'scope',
  safety: 'safety',
  capture: 'contact-form',
  routing: 'after-diagnosis',
  placement: 'placement',
  handoff: 'app-handoff',
  analytics: 'analytics',
};

/** Older and informal keys → the tab they open. */
export const TAB_ALIASES: Record<string, ConfigGroup> = {
  form: 'capture',
  contact: 'capture',
  capture: 'capture',
  after: 'routing',
  routing: 'routing',
  'routing-actions': 'routing',
  app: 'handoff',
  handoff: 'handoff',
};

export function tabSlug(group: ConfigGroup): string {
  return TAB_SLUGS[group];
}

/** The URL of one Widget settings tab. */
export function settingsTabPath(group: ConfigGroup): string {
  return `/config?tab=${tabSlug(group)}`;
}
